import React from "react";
import styles from "./StatusBadge.module.css";

const StatusBadge = ({ status }: { status: string }) => {
  const getStatusClass = () => {
    switch (status.toLowerCase()) {
      case "paid":
      case "active":
        return styles.active;
      case "banned":
      case "out of date":
        return styles.error;
      case "progress":
      case "pending":
        return styles.warning;
      default:
        return styles.default;
    }
  };

  return (
    <span className={`${styles.badge} ${getStatusClass()}`}>{status}</span>
  );
};

export default StatusBadge;
